import { render, staticRenderFns } from "./CreateProductCategoryDialog.vue?vue&type=template&id=3596a5c5&scoped=true"
import script from "./CreateProductCategoryDialog.vue?vue&type=script&lang=js"
export * from "./CreateProductCategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3596a5c5",
  null
  
)

export default component.exports